import { baseActions, baseMutations } from '../base'
import { formatDate } from '@/helpers/dateHelper'

const initialState = () => {
  return {
    module: 'stadiums',
    model: 'stadium',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      active: true,
      name: '',
      // photo: 'default-stadium.png',
      countryId: '',
      provinceId: '',
      townId: '',
      cp: '',
      lat: '',
      long: '',
    },
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        country: item.countryId ? item.countryId.name : '-',
        province: item.provinceId ? item.provinceId.name : '-',
        town: item.townId ? item.townId.name : '-',
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      if (item.photo) {
        if (item.photo.includes('http')) result.photo = item.photo
        else result.photo = process.env.VUE_APP_IMAGE_URL + item.photo
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
